import { render, staticRenderFns } from "./coderProject.vue?vue&type=template&id=c1128e0a&scoped=true&"
import script from "./coderProject.vue?vue&type=script&lang=js&"
export * from "./coderProject.vue?vue&type=script&lang=js&"
import style0 from "./coderProject.vue?vue&type=style&index=0&id=c1128e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1128e0a",
  null
  
)

export default component.exports